import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { SimpleRouterState } from '@platform-frontend/util';
import { AcademicState } from './academic.state';

export const UserTypeGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const store = inject(Store);
  if (store.selectSnapshot(SimpleRouterState.guardsActivated)) {
    const allowedUserTypes = route.data.allowedUserTypes as Array<string>;
    const userType = store.selectSnapshot(AcademicState.userType);
    return userType !== null && allowedUserTypes.includes(userType);
  } else {
    return true;
  }
};
